// extracted by mini-css-extract-plugin
export default {"itemParameters":"_2oHc_","itemName":"_3V4pD","itemValue":"B6X7c","parametersList":"_1O2tT"};